import React from "react";
import { Container, Grid } from "@mui/material";
import CounterCard from "./CounterCard";
const Counter = () => {
    return(
        <div id="tokenomics" className="SP---counter bg-light mt-sm-5 py-5">
            <Container maxWidth="lg">
                <Grid
                    container
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <CounterCard 
                        counterNumber="1,000,000"
                        subtitle="Total Supply"
                        customClass="broderCol pb-5 py-sm-5 pl-5"
                    />
                    <CounterCard 
                        counterNumber="550,000"
                        subtitle="Liquidity Provision"
                        customClass="broderCol py-5 py-md-5 pl-5"
                    />
                    <CounterCard 
                        counterNumber="450,000"
                        subtitle="Initial Liquidity"
                        customClass="broderCol py-5 pl-5"
                    />
                    <CounterCard 
                        counterNumber="0"
                        subtitle="Marketing"
                        customClass="pt-5 pb-sm-5 pl-5"
                    />
                </Grid>
            </Container>
        </div>
    )
}

export default Counter;
